module.exports = __webpack_public_path__ + "static/img/f1.0344296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/pit/mine/f1.png
// module id = vvT0
// module chunks = 0